export const YLOPO_BASE_URL = `https://homebot.ylopo.com/search`
